import { OthersStoriesSectionContent } from '@/types';

export const othersStories: OthersStoriesSectionContent = {
  headline: {
    before: 'All Success',
    highlight: 'Stories'
  }
};
